// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"212":"96f27d0a","804":"717dd470"}[chunkId] + ".css";
};